module.exports = __webpack_public_path__ + "img/type6.08d3d22c.png";